.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--z-index-three);
    transition: all 0.3s linear;
    background-color: rgba(0, 0, 0, 0);
}

.visible {
    background-color: rgba(0, 0, 0, 0.75);
}

.transparent {
    background-color: rgba(0, 0, 0, 0);
}
